import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CustomClipboard } from './clipboardTypes';

const initialState: CustomClipboard = null;

const clipboardSlice = createSlice({
  name: 'clipboard',
  initialState: initialState as CustomClipboard,
  reducers: {
    abortClipboard: () => null,
    saveClipboard: (
      state: CustomClipboard,
      action: PayloadAction<CustomClipboard>
    ) => {
      state = action.payload;

      return action.payload;
    },
  },
});

export const { abortClipboard, saveClipboard } = clipboardSlice.actions;

export default clipboardSlice.reducer;
